import UserJson from "../user/UserJson.js";
import AccessLevel from "../AccessLevel.js";
import {formattedDateFromMillis} from "../../util/CommonUtils.js";

export default class Post{
    /** @type {string} */
    #id;
    /** @type {string} */
    #title;
    /** @type {string} */
    #body;
    /** @type {UserJson} */
    #author;
    /** @type {number} */
    #created;
    /** @type {number} */
    #updated;
    /** @type {AccessLevel} */
    #userAccessLevel;

    /**
     * @param {string} id
     * @param {string} title
     * @param {string} body
     * @param {UserJson} author
     * @param {number} created
     * @param {number} updated
     * @param {AccessLevel} userAccessLevel
     */
    constructor(id, title, body, author, created, updated,
                userAccessLevel) {
        this.#id = id;
        this.#title = title;
        this.#body = body;
        this.#author = author;
        this.#created = created;
        this.#updated = updated;
        this.#userAccessLevel = userAccessLevel;
    }

    /** @returns {string} */
    get id(){
        return this.#id
    }

    /** @returns {string} */
    get title(){
        return this.#title
    }

    /** @returns {string} */
    get name(){
        return this.#title
    }

    /** @returns {string} */
    get body (){
        return this.#body
    }

    /** @returns {UserJson} */
    get author(){
        return this.#author;
    }

    /** @returns {AccessLevel} */
    get userAccessLevel(){
        return this.#userAccessLevel;
    }

    /** @returns {string} */
    get lastUpdatedDate(){
        return formattedDateFromMillis(new Date(this.#updated).getTime());
    }

    /**
     * @param {{
     * id: string,
     * title: string,
     * body: string,
     * author: {},
     * created: number,
     * updated: number,
     * userAccessLevel: number}} json
     * @returns {Post}
     */
    static parseServerJson(json){
        return new Post(json.id, json.title, json.body, UserJson.parseServerJson(json.author), json.created,
            json.updated, new AccessLevel(json.userAccessLevel))
    }

    /**
     * @param {{
     * id: string,
     * title: string,
     * body: string,
     * author: {},
     * created: number,
     * updated: number,
     * userAccessLevel: number}[]}json
     * @returns {Post[]}
     */
    static parseServerJsonMany(json){
        const result = [];
        for (const j of json){
            result.push(Post.parseServerJson(j))
        }
        return result;
    }
}